/**
 * Normaliza um texto para comparação de chaves (ids de módulo e grupos):
 * remove acentos, converte para minúsculo e troca separadores por "-".
 *
 * Exemplos: "Governança e Auditoria" -> "governanca-e-auditoria",
 *           "PERFIL_INVESTIMENTO" -> "perfil-investimento".
 */
export function normalizarChave(value?: string | null): string {
  if (!value) {
    return '';
  }

  return value
    .normalize('NFD')
    // Remove os acentos separados pelo normalize (marcas de combinação).
    .replace(/[^\x00-\x7F]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
